
var automaticLoadingActions = [
    'base/MMFLoadRows'
];

function hasAutomaticLoading(type) {
    return automaticLoadingActions.indexOf(type) >= 0;
}

export default {
    install (Vue, store ) {
        if (!store) {
            console.error('Vuex store not defined!');
        }

        store.subscribeAction({
            before: (action, state) => {
                if (hasAutomaticLoading(action.type)) {
                    store.dispatch("base/showLoading", {root: true});
                }
            },
            after: (action, state) => {
                if (hasAutomaticLoading(action.type)) {
                    store.dispatch("base/hideLoading", {root: true});
                }
            }
        });
    }
}